<template>
  <div
    class="modal modal-opportunity-create fade fixed-end"
    tabindex="-1"
    role="dialog"
  >
    <div
      class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="drawer-title">
            {{ title }}
          </h2>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <!-- /.drawer-heading -->

        <div class="modal-body">
          <div class="mb-3">
            <label class="control-label">Opportunity Name</label>
            <input
              name="name"
              v-model="newOpportunity.name"
              type="text"
              class="form-control"
              data-vv-validate-on="input|blur"
              data-vv-as="name"
              v-validate="'required'"
              :disabled="isApproved"
            />
            <help-block field="name" />
          </div>

          <div class="mb-3">
            <label class="control-label">Type</label>
            <multiselect
              :show-labels="false"
              v-model="newOpportunity.lead_type"
              :options="types"
              v-validate="'required'"
              data-vv-name="type"
              :disabled="isApproved"
            ></multiselect>
            <help-block field="type" />
          </div>
          <!-- /.form-group -->

          <div class="mb-3">
            <label class="control-label">Due Date</label>
            <input
              name="due_date"
              v-model="newOpportunity.due_date"
              type="date"
              class="form-control"
              :disabled="isApproved"
            />
            <help-block field="due_date" />
          </div>

          <div class="mb-3">
            <label class="control-label">Select Client</label>
            <div class="input-group">
              <span class="input-group-text">
                <i class="fal fa-fw fa-building"></i>
              </span>
              <multiselect
                :show-labels="false"
                v-model="client"
                :options="clients"
                label="company"
                track-by="id"
                placeholder=""
                v-validate="'required'"
                data-vv-name="client"
                @select="clientSelected"
                :disabled="isApproved"
              >
                <template slot="beforeList">
                  <a href=""
                    style="padding:10px;"
                    data-bs-toggle="modal"
                    data-bs-target=".modal-client-create"
                  >
                    Add New Client
                  </a>
                </template>
                <template slot="singleLabel" slot-scope="props">
                  <span style="display:inline-flex;align-items:center;">
                    <span class="option__title">{{ props.option.company }}</span>
                    <span v-if="props.option.xero_id" class="badge badge-pill" style="background-color:#13b5ea;color:#fff;margin-left:8px;">Xero</span>
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span style="display:inline-flex;align-items:center;">
                      <span class="option__title">{{ props.option.company }}</span>
                      <span v-if="props.option.xero_id" class="badge badge-pill" style="background-color:#13b5ea;color:#fff;margin-left:8px;">Xero</span>
                    </span>
                    <span v-if="props.option.display_name && props.option.display_name !== props.option.company" class="option__small" style="display:block;">{{ props.option.display_name }}</span>
                  </div>
                </template>
              </multiselect>
            </div>
            <help-block field="client" />
          </div>
          <!-- /.form-group -->

          <div class="mb-3" v-if="client">
            <label class="control-label">Select Contact</label>
            <div class="input-group">
              <span class="input-group-text">
                <i class="fal fa-fw fa-address-card"></i>
              </span>
              <multiselect
                :show-labels="false"
                v-model="contact"
                :options="contacts"
                label="name"
                track-by="id"
                placeholder=""
                v-validate="'required'"
                data-vv-name="contact"
                @select="contactSelected"
                :disabled="isApproved"
              >
                <template slot="beforeList">
                  <a
                    style="padding:10px;"
                    href=".drawer-contact"
                    data-bs-toggle="modal"
                    data-bs-target=".modal-contact-create"
                  >
                    Add Contact
                  </a>
                </template>
                <template slot="singleLabel" slot-scope="props"
                  ><span class="option__title">{{ props.option.name }}</span
                  ><span class="option__small">{{
                    props.option.email
                  }}</span></template
                >
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__title">{{ props.option.name }}</span
                    ><span class="option__small">{{
                      props.option.email
                    }}</span>
                  </div>
                </template>
              </multiselect>
            </div>
            <help-block field="contact" />
          </div>
          <!-- /.form-group -->

          <div class="mb-3">
            <label class="control-label">Owner</label>
            <div class="input-group">
              <span class="input-group-text">
                <i class="fal fa-fw fa-user"></i>
              </span>
              <multiselect
                :show-labels="false"
                v-model="user"
                :options="users"
                label="name"
                track-by="id"
                placeholder="Select Owner"
                v-validate="'required'"
                data-vv-name="user"
                @select="ownerSelected"
                :disabled="isApproved"
              ></multiselect>
            </div>
            <help-block field="user" />
          </div>
          <!-- /.form-group -->

          <div v-if="client" class="mb-3">
            <label class="control-label">Retainer</label>
            <div class="input-group">
              <span class="input-group-text">
                <i class="fal fa-fw fa-sync"></i>
              </span>
              <multiselect
                :show-labels="false"
                v-model="retainer"
                :options="clientRetainers"
                :custom-label="retainerLabel"
                track-by="id"
                placeholder="Select Retainer (Optional)"
                :allow-empty="true"
                @select="retainerSelected"
                @remove="retainerDeselected"
                :disabled="isApproved"
              ></multiselect>
            </div>
          </div>

          <div v-if="user" class="mb-3">
            <label class="control-label">Secondary Owner</label>
            <div class="input-group">
              <span class="input-group-text">
                <i class="fal fa-fw fa-user"></i>
              </span>
              <multiselect
                :show-labels="false"
                v-model="secondary"
                :options="secondaryUserOptions"
                label="name"
                track-by="id"
                placeholder="Select Secondary"
                data-vv-name="user"
                @input="secondarySelected"
                :disabled="isApproved"
              ></multiselect>
            </div>
            <help-block field="user" />
          </div>
          <!-- /.form-group -->

          <div class="row mb-3">
            <div class="col-6">
              <label class="control-label">Expected</label><br/>
              <small class="form-text text-muted">Expected signing date</small>
              <input
                name="expected"
                v-model="newOpportunity.expected"
                type="date"
                class="form-control"
              />
            </div>
            <div class="col-6">
              <label class="control-label">Confidence</label><br/>
              <small class="form-text text-muted">Confidence of sale</small>
              <div class="input-group">
                <input
                  name="name"
                  v-model="newOpportunity.confidence"
                  type="number"
                  class="form-control"
                />
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon1">%</span>
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-6">
              <label class="control-label">Client Budget</label><br/>
              <small class="form-text text-muted">Are we working within a budget?</small
              >
              <div class="input-group">
                <span class="input-group-text" id="basic-addon1">$</span>
                <input
                  name="name"
                  @input="updateBudgetValues"
                  v-model="newOpportunity.client_budget"
                  type="number"
                  class="form-control pl-2"
                  :disabled="isApproved"
                />
              </div>
            </div>
            <div class="col-6">
              <label class="control-label">Potential Value</label><br/>
              <small class="form-text text-muted">Complete project potential value.</small>
              <div class="input-group">
                <span class="input-group-text" id="basic-addon1">$</span>
                <input
                  name="name"
                  v-model="newOpportunity.project_value"
                  type="number"
                  class="form-control pl-2"
                  :disabled="isApproved"
                />
              </div>
            </div>
          </div>
          <div v-if="$can('read sales')" class="row mb-3">
            <div class="col-6">
              <label class="control-label">License Fee</label>
              <div class="input-group">
                <span class="input-group-text" id="basic-addon1">$</span>
                <input
                  name="name"
                  v-model="newOpportunity.license_fee"
                  type="number"
                  class="form-control pl-2"
                  :disabled="isApproved"
                />
              </div>
            </div>
            <div class="col-6">
              <label class="control-label">Margin <small></small></label>
              <div class="input-group">
                <span class="input-group-text" id="basic-addon1">$</span>
                <input
                  disabled
                  name="name"
                  v-model="newOpportunity.margin"
                  type="number"
                  class="form-control pl-2"
                />
              </div>
            </div>
          </div>
          <div v-if="$can('read sales')" class="row mb-3">
            <div class="col-12">
              <p>
                <small>Budget for scoping: </small>
                <span :class="{ 'text-danger': scopingBudget < 50000 }">${{ scopingBudget | currency0 }}</span>
              </p>
              <p>
                <small>Budget for development: </small>
                <span :class="{ 'text-danger': deliveryBudget < 50000 }">${{ deliveryBudget | currency0 }}</span>
              </p>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <c-button
              @click="handleSaveOpportunity"
              class="btn btn-primary"
              >Save</c-button>
          </div>
        </div>
        <!-- /.drawer-body -->
      </div>
      <!-- /.drawer-contents -->
    </div>
    <!-- /.drawer -->
  </div>
</template>

<style scoped>
.invalid-feedback {
  display: inline-block;
}
</style>

<style>
.form-control {
  box-shadow: none !important;
}

.form-control[readonly] {
  background-color: transparent !important;
}
</style>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { http } from "utils";
import { Selectize, LaddaButton } from "components/form/input";
import Datepicker from "vuejs-datepicker";
import $ from "jquery";
import { notify } from "utils";
import { unset, cloneDeep, filter } from "lodash";
import moment from "moment";
import Multiselect from "vue-multiselect";
import { helperMethods } from "vx/modules/clients";
import { CModal } from '@chameleon/chameleon-vue'

export default {
  $_veeValidate: {
    validator: "new", // give me my own validator scope.
  },
  props: ["title", "opportunity"],
  extends: CModal,
  components: {
    Selectize,
    LaddaButton,
    Datepicker,
    Multiselect,
  },

  data() {
    return {
      newOpportunity: {},
      types: [
        "Stage 1",
        "Stage 2",
        "Stage 3",
        "Stage 1 & 2",
        "Variation",
        "Full Budget",
        "T&M",
        "Consult",
        "Template",
      ],
      client: null,
      contact: null,
      user: null,
      secondary: null,
      retainer: null,
      margin: 0.15,
    };
  },

  mounted() {
    this.getClients();
    this.getUsers();
    this.getRetainers();

    this.addEventListener('open', () => {
      this.newOpportunity = cloneDeep(this.opportunity);

      if (this.newOpportunity.client_id) {
        this.client = this.getClientById(this.newOpportunity.client_id);

        this.getContacts(this.newOpportunity.client_id).then(() => {
          this.contact = this.getContactById(this.newOpportunity.contact_id);
        });

        this.user = this.getUserById(this.newOpportunity.user_id);
        this.secondary = this.getUserById(this.newOpportunity.secondary_user_id);

        if (this.newOpportunity.retainer_id) {
          this.retainer = this.retainers.find(r => r.id === this.newOpportunity.retainer_id) || null;
        } else {
          this.retainer = null;
        }
      }
    })

    this.$bus.$on("newClientCreated", (clientId) => {
      this.getClients().then(() => {
        this.client = this.getClientById(clientId);
        this.newOpportunity.client_id = clientId;

        //Auto select first contact when new client is created
        this.getContacts(clientId).then(() => {
          this.contact = this.getContactById(this.contacts[0].id);
          this.newOpportunity.contact_id = this.contact.id;
        });
      });
    });

    this.$bus.$on("newContactCreated", (contactId) => {
      this.getContacts(this.newOpportunity.client_id).then(() => {
        this.contact = this.getContactById(contactId);
        this.newOpportunity.contact_id = this.contact.id;
      });
    });
  },

  computed: {
    ...mapState("contacts", ["contacts"]),
    ...mapState("contacts", ["client_id"]),
    ...mapState("clientsList", ["clients"]),
    ...mapState("users", ["users"]),
    ...mapState("retainersList", { retainers: "retainers" }),
    ...mapGetters("clientsList", { getClientById: "getById" }),
    ...mapGetters("contacts", { getContactById: "getById" }),
    ...mapGetters("users", { getUserById: "getById" }),

    isApproved() {
      return this.newOpportunity && this.newOpportunity.approved_at != null
    },

    clientRetainers() {
      if (!this.client) return [];
      return this.retainers.filter(r => r.client_id === this.client.id);
    },

    calculatedMargin() {
      return 0;
    },

    secondaryUserOptions () {
      return filter(this.users, (user) => {
        return this.user.id !== user.id
      })
    },

    scopingBudget() {
      if (!this.newOpportunity.client_budget) { return 0 }

      var scopingBudget = this.newOpportunity.client_budget * 0.2;
      return scopingBudget / 1.1;
    },

    deliveryBudget() {
      if (!this.newOpportunity.client_budget) { return 0 }

      var devBudget = this.newOpportunity.client_budget * 0.8;
      return Math.max(0, (devBudget / 1.15) - this.newOpportunity.license_fee);
    },
  },

  methods: {
    ...helperMethods,
    ...mapActions("opportunity", ["addSingle", "updateSingle"]),
    ...mapActions("clientsList", ["getClients"]),
    ...mapActions("users", ["getUsers"]),
    ...mapActions("contacts", ["getContacts"]),
    ...mapActions("client", ["setClient"]),
    ...mapActions("retainersList", ["getRetainers"]),

    updateBudgetValues() {
      //70% is the extimated percentage of the budget being for development
      var devBudget = this.newOpportunity.client_budget * 0.8;
      var scopingBudget = this.newOpportunity.client_budget * 0.2;

      // license fee can't be less than 20k
      this.newOpportunity.license_fee = Math.max(
        20000,
        devBudget - (devBudget / 1.25)
      ).toFixed();

      // specific margin is to the respective stage
      this.newOpportunity.margin = (
        (devBudget - (devBudget / 1.15)) +
        (scopingBudget - (scopingBudget / 1.1))
      ).toFixed();
    },

    retainerLabel(retainer) {
      const start = retainer.start ? moment(retainer.start).format('DD/MM/YYYY') : 'N/A';
      const end = retainer.end ? moment(retainer.end).format('DD/MM/YYYY') : 'Ongoing';
      return `$${retainer.amount} (${start} - ${end})`;
    },

    retainerSelected(selected) {
      this.newOpportunity.retainer_id = selected.id;
    },

    retainerDeselected() {
      this.newOpportunity.retainer_id = null;
      this.retainer = null;
    },

    clientSelected(selected) {
      this.newOpportunity.client_id = selected.id;
      //Ensure no contact is selected from a previous client selection
      this.contact = null;
      this.getContacts(selected.id);

      // Pre-select retainer if client has an active one
      this.$nextTick(() => {
        if (this.clientRetainers.length > 0) {
          this.retainer = this.clientRetainers[0];
          this.newOpportunity.retainer_id = this.retainer.id;
        } else {
          this.retainer = null;
          this.newOpportunity.retainer_id = null;
        }
      });
    },

    ownerSelected(selected) {
      this.newOpportunity.user_id = selected.id;

      if (this.secondary && this.secondary.id === selected.id) {
        this.secondary = null
      }
    },

    secondarySelected(selected) {
      if (selected) {
        this.newOpportunity.secondary_user_id = selected.id
      } else {
        this.newOpportunity.secondary_user_id = null
      }
    },

    contactSelected(selected) {
      this.newOpportunity.contact_id = selected.id;
    },

    typeSelected(selected) {
      this.newOpportunity.lead_type = selected.id;
    },

    handleSaveOpportunity() {
      if (this.newOpportunity.id) {
        return this.handleUpdateOpportunity();
      } else {
        return this.handleAddOpportunity();
      }
    },

    async handleAddOpportunity() {
      if (!(await this._validate())) {
        notify.error(
          "Form validation failed, please check your inputs and try again."
        );
        return Promise.reject();
      }

      try {
        return this.addSingle(this.newOpportunity)
          .then((response) => {
            //Redirect to new opp
            this.close()
            this.$emit('created')
          })
          .catch((error) => {
            if (error.response.status === 422) {
              notify.error(
                "Form validation failed, please check your inputs and try again."
              );
            } else {
              console.error(error);
              notify.error("Failed to create opportunity, please try again.");
            }
          });
      } catch (error) {
        console.error(error);
      }
    },

    async handleUpdateOpportunity() {
      if (!(await this._validate())) {
        notify.error(
          "Form validation failed, please check your inputs and try again."
        );
        return Promise.reject();
      }

      try {
        return this.updateSingle({
          id: this.newOpportunity.id,
          payload: this.newOpportunity,
        })
          .then((response) => {
            //Redirect to new opp
            //this.$router.push({ name: 'opportunities.show', params: { opportunity_id: response.data.id } })

            notify.success("Opportunity successfuly updated.");
            this.close()
            this.$emit('updated')
          })
          .catch((error) => {
            if (error.response.status === 422) {
              notify.error(
                "Form validation failed, please check your inputs and try again."
              );
            } else {
              console.error(error);
              notify.error("Failed to create opportunity, please try again.");
            }
          });
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
